import { AppSettings } from "../../app-settings";
import { Utilities } from "./utilities";
import * as BootstrapDialog from "bootstrap3-dialog";
const template = require<string>("../templates/application-refresh-exceeded.html");

export class VersionChecker {
    public static async checkForUpdates() {
        const response =
            await Promise.resolve($.get(`${AppSettings.ApiUrlPrefix}status`))
            .catch(() => {
                // Set timer again if there was an exception thrown to ensure we still do an app version check
                setTimeout(() => { this.checkForUpdates(); }, AppSettings.AppVersionWatchInterval);
            });

        if (!response) {
            throw new Error("Unexpected server response");
        }
        const apiExpectsAppVersion = response.AppVersion;
        const currentAppVersion = AppSettings.AppVersion;

        if (!apiExpectsAppVersion || !currentAppVersion) {
            // We don't have all the info to decide if to do an app reload. This happens if the string values are null, undefined or empty ("")
            return;
        }

        if (Utilities.VersionCompare(apiExpectsAppVersion, currentAppVersion) === 1) {
            let attempt: number;
            if (window.localStorage) {
                attempt = window.localStorage.getItem("failed_startup_attempt") === null ? 0 : +window.localStorage.getItem("failed_startup_attempt");
                window.localStorage.setItem("failed_startup_attempt", (++attempt).toString());
            }

            if (attempt < +(AppSettings.MaxApplicationRestarts)) {
               window.location.reload(true);
            } else {
                if (window.localStorage) {
                    window.localStorage.setItem("failed_startup_attempt", "0");
                }
                BootstrapDialog.show({
                    title: "An update is available",
                    message: $(Mustache.render(template, {expectedVersion: apiExpectsAppVersion, currentVersion: currentAppVersion})),
                    closable: false,
                });
            }
        }
        else {
            if (window.localStorage) {
                window.localStorage.setItem("failed_startup_attempt", "0");
            }
            setTimeout(() => { this.checkForUpdates(); }, AppSettings.AppVersionWatchInterval);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/version-checker.ts